import type {PartialOptions} from "../../../../../stem-core/ui/UIBase";
import {UI} from "../../../../../stem-core/ui/UIBase";

import {BlinkButton} from "../../../../../core/ui/Button.jsx";
import {Messages} from "../../../../Messages.js";
import {PaymentMethod} from "../../../../../client/state/PaymentMethodStore.js";
import {Wallet} from "../../../../../client/state/WalletStore.js";
import {ADD_FUNDS_DISABLE_TIMEOUT} from "../../../../Constants.js";
import {Toast} from "../../../../ui/Toast.jsx";
import {wrapInSpinner} from "../../../../../core/ui/LoadingSpinner.jsx";
import {Money} from "../../../../../stem-core/localization/Money.js";
import {apiUserTopUp, TopUpStatus} from "../../../../../client/state/TopUpPaymentStore.js";
import type {ExtendedOptions} from "../../../../../stem-core/ui/UIBase";


interface AddFundsButtonOptions {
    amount?: number;
    onNoPaymentMethod?: (...args: any[]) => void;
    userWallet?: Wallet;
}

export class AddFundsButton extends BlinkButton {
    // BlinkButton fixes its own options type and doesn't forward a type argument
    declare options: ExtendedOptions<BlinkButton, AddFundsButtonOptions>;

    getDefaultOptions(options?: this["options"]): PartialOptions<AddFundsButton> {
        return {
            ...super.getDefaultOptions(options),
            amount: 0,
            userWallet: Wallet.getWallet(),
            onClick: () => this.addFunds(),
            onNoPaymentMethod: null, // Required to be passed in
        };
    }

    render() {
        const {amount, userWallet} = this.options;
        const moneyAmount = new Money(amount, userWallet.getCurrency());
        return Messages.addFundsAmount(moneyAmount.toMainUnitString({decimalsDisplayed: 0}));
    }

    @wrapInSpinner
    async addFunds() {
        const {amount, userWallet, onNoPaymentMethod} = this.options;
        const primaryCard = PaymentMethod.getPrimary();
        if (!primaryCard) {
            onNoPaymentMethod();
            return;
        }
        Toast.hide();
        this.tempDisable(ADD_FUNDS_DISABLE_TIMEOUT);

        try {
            const transaction = await apiUserTopUp(amount, primaryCard, userWallet);
            if (transaction.status !== TopUpStatus.SUCCEEDED) {
                throw null;
            }
        } catch (error) {
            Toast.showError(error, Messages.failedAddFunds);
        }
    }
}
